ace.define("ace/mode/spel_umd",[], function(require, exports, module){!function (r, e) { "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("TsSpel", [], e) : "object" == typeof exports ? exports.TsSpel = e() : r.TsSpel = e(); }(this, (function () { return (function () {
    "use strict";
    var r = { 543: function (r, e, n) { var t, o = this && this.__extends || (t = function (r, e) { return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (r, e) { r.__proto__ = e; } || function (r, e) { for (var n in e)
            Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]); }, t(r, e); }, function (r, e) { if ("function" != typeof e && null !== e)
            throw new TypeError("Class extends value " + String(e) + " is not a constructor or null"); function n() { this.constructor = r; } t(r, e), r.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n); }); Object.defineProperty(e, "__esModule", { value: !0 }), e.UnexpectedError = e.RuntimeError = e.ParsingError = void 0; var i = n(631), a = function (r) { function e(e, n, t, o, i) { void 0 === o && (o = t); var a = r.call(this, o, { cause: i }) || this; return a.expression = e, a.index = n, a.reason = t, a; } return o(e, r), e; }(i.CustomError); e.ParsingError = a; var u = function (r) { function e(e, n, t) { var o = r.call(this, n, { cause: t }) || this; return o.ast = e, o; } return o(e, r), e; }(i.CustomError); e.RuntimeError = u; var l = function (r) { function e(e, n) { return r.call(this, e, { cause: n }) || this; } return o(e, r), e; }(i.CustomError); e.UnexpectedError = l; }, 750: function (r, e, n) { Object.defineProperty(e, "__esModule", { value: !0 }), e.getEvaluator = void 0; var t = n(543), o = function (r) { return { _tag: "some", isSome: !0, value: r }; }, i = { _tag: "none", isSome: !1 }, a = function (r) { return "some" === r._tag; }, u = function (r) { return "none" === r._tag; }, l = function (r) { return void 0 === r ? i : o(r); }; e.getEvaluator = function (r, e) { var n = [r], f = function () { if (n.length > 0)
            return n[n.length - 1]; throw new t.UnexpectedError("Stack is empty"); }, s = function (r) { return "this" === r ? o(f()) : "root" === r ? o(n[0]) : l(e[r]); }, c = function (r) { return n.reduce((function (e, n) { return a(e) ? e : "this" === r ? o(n) : null != n ? l(n[r]) : i; }), i); }, p = function (r) { return function (e, n) { var t = g(e), o = g(n); if ("number" != typeof t)
            throw new Error(JSON.stringify(t) + " is not a float"); if ("number" != typeof o)
            throw new Error(JSON.stringify(o) + " is not a float"); return r(t, o); }; }, h = function (r, e, t) { var o = (t ? r.reverse() : r).find((function (r) { n.push(r); var t = g(e); if (n.pop(), "boolean" != typeof t)
            throw new Error("Result of selection expression is not Boolean"); return !0 === t; })); return void 0 === o ? null : o; }, g = function (e) { var t, o, i; switch (e.type) {
            case "BooleanLiteral":
            case "NumberLiteral":
            case "StringLiteral": return e.value;
            case "CompoundExpression":
                var l = e.expressionComponents.reduce((function (r, e) { var t = g(e); return n.push(t), t; }), r);
                return e.expressionComponents.forEach((function () { n.pop(); })), l;
            case "Elvis":
                var v = g(e.expression);
                return null === v ? g(e.ifFalse) : v;
            case "FunctionReference":
                var y = s(e.functionName), w = e.args.map(g);
                if (u(y)) {
                    if (e.nullSafeNavigation)
                        return null;
                    throw new Error("Method " + e.functionName + " not found.");
                }
                if ("function" != typeof (O = y.value))
                    throw new Error("Variable " + e.functionName + " is not a function.");
                return O.apply(void 0, w);
            case "Indexer":
                if (null === (T = f()) && e.nullSafeNavigation)
                    return null;
                var d = g(e.index);
                if ("string" == typeof T && "number" == typeof d) {
                    if (d >= 0 && d < T.length)
                        return T[d];
                    throw new Error("index " + d + " is out of range on string " + JSON.stringify(T));
                }
                if (Array.isArray(T) && "number" == typeof d) {
                    if (d >= 0 && d < T.length)
                        return T[d];
                    throw new Error("index " + d + " is out of range on array " + JSON.stringify(T));
                }
                if (T && "object" == typeof T && ("string" == typeof d || "number" == typeof d)) {
                    if (Object.prototype.hasOwnProperty.call(T, d))
                        return T[d];
                    throw new Error("key " + d + " not found in dictionary " + JSON.stringify(T));
                }
                throw new Error("Not supported: indexing into " + JSON.stringify(T) + " with " + JSON.stringify(d));
            case "InlineList": return e.elements.map(g);
            case "InlineMap": return Object.entries(e.elements).reduce((function (r, e) { var n = e[0], t = e[1]; return r[n] = g(t), r; }), {});
            case "MethodReference":
                var E = c(e.methodName);
                if (a(E)) {
                    var O = E.value;
                    if (w = e.args.map(g), "function" == typeof O)
                        return O.apply(void 0, w);
                }
                else {
                    var x = f();
                    if (Array.isArray(x)) {
                        if ("size" === e.methodName)
                            return x.length;
                        if ("contains" === e.methodName)
                            return x.includes(g(e.args[0]));
                    }
                    if (!e.nullSafeNavigation)
                        throw new Error("Method " + e.methodName + " not found.");
                }
                return null;
            case "Negative":
                var S = g(e.value);
                if ("number" == typeof S)
                    return -1 * S;
                throw new Error("unary (-) operator applied to " + JSON.stringify(S));
            case "NullLiteral": return null;
            case "OpAnd":
                var N = g(e.left), m = g(e.right);
                if (null !== N && "boolean" != typeof N)
                    throw new Error(JSON.stringify(N) + " is not a null/boolean");
                if (null !== m && "boolean" != typeof m)
                    throw new Error(JSON.stringify(m) + " is not a null/boolean");
                return N && m;
            case "OpDivide": return p((function (r, e) { return r / e; }))(e.left, e.right);
            case "OpEQ": return (N = g(e.left)) === g(e.right);
            case "OpGE": return p((function (r, e) { return r >= e; }))(e.left, e.right);
            case "OpGT": return p((function (r, e) { return r > e; }))(e.left, e.right);
            case "OpLE": return p((function (r, e) { return r <= e; }))(e.left, e.right);
            case "OpLT": return p((function (r, e) { return r < e; }))(e.left, e.right);
            case "OpMatches": return (i = function (r, e) { return RegExp(e).test(r); }, function (r, e) { var n = g(r), t = g(e); if ("string" != typeof n)
                throw new Error(JSON.stringify(n) + " is not a string"); if ("string" != typeof t)
                throw new Error(JSON.stringify(t) + " is not a string"); return i(n, t); })(e.left, e.right);
            case "OpBetween":
                if (N = g(e.left), m = g(e.right), !Array.isArray(m) || 2 !== m.length)
                    throw new Error("Right operand for the between operator has to be a two-element list");
                var P = m[0], b = m[1];
                return P <= N && N <= b;
            case "OpMinus": return p((function (r, e) { return r - e; }))(e.left, e.right);
            case "OpModulus": return p((function (r, e) { return r % e; }))(e.left, e.right);
            case "OpMultiply": return p((function (r, e) { return r * e; }))(e.left, e.right);
            case "OpNE": return (N = g(e.left)) !== g(e.right);
            case "OpNot": return !g(e.expression);
            case "OpOr": return N = g(e.left), m = g(e.right), Boolean(N || m);
            case "OpPlus": return p((function (r, e) { return r + e; }))(e.left, e.right);
            case "OpPower": return p((function (r, e) { return Math.pow(r, e); }))(e.base, e.expression);
            case "Projection":
                var _ = e.nullSafeNavigation, j = e.expression;
                if (null === (T = f()) && _)
                    return null;
                if (Array.isArray(T))
                    return T.map((function (r) { n.push(r); var e = g(j); return n.pop(), e; }));
                if (T && "object" == typeof T)
                    return Object.values(T).map((function (r) { n.push(r); var e = g(j); return n.pop(), e; }));
                throw new Error("Cannot run expression on non-array " + JSON.stringify(T));
            case "PropertyReference":
                _ = e.nullSafeNavigation;
                var M = e.propertyName;
                if (E = c(M), u(E)) {
                    if (_)
                        return null;
                    throw new Error("Null Pointer Exception: Property " + JSON.stringify(M) + " not found in context " + JSON.stringify(n));
                }
                return E.value;
            case "SelectionAll":
                _ = e.nullSafeNavigation;
                var A = e.expression;
                if (null === (T = f()) && _)
                    return null;
                if (Array.isArray(T))
                    return T.filter((function (r, e) { n.push(r); var t = g(A); if (n.pop(), "boolean" != typeof t)
                        throw new Error("Result " + JSON.stringify(t) + " at index " + e + " of selection expression is not Boolean"); return !0 === t; }));
                if (T && "object" == typeof T)
                    return Object.fromEntries(Object.entries(T).filter((function (r, e) { var t = r[0], o = r[1]; n.push({ key: t, value: o }); var i = g(A); if (n.pop(), "boolean" != typeof i)
                        throw new Error("Result " + JSON.stringify(i) + " at index " + e + " of selection expression is not Boolean"); return !0 === i; })));
                throw new Error("Cannot run selection expression on non-collection " + JSON.stringify(T));
            case "SelectionFirst":
                _ = e.nullSafeNavigation;
                var L = e.expression;
                if (null === (T = f()) && _)
                    return null;
                if (Array.isArray(T))
                    return h(T, L, !1);
                if (T && "object" == typeof T) {
                    var J = h(Object.entries(T).map((function (r) { return { key: r[0], value: r[1] }; })), L, !1);
                    return J && ((t = {})[J.key] = J.value, t);
                }
                throw new Error("Cannot run selection expression on non-array " + JSON.stringify(T));
            case "SelectionLast":
                var T;
                if (_ = e.nullSafeNavigation, L = e.expression, null === (T = f()) && _)
                    return null;
                if (Array.isArray(T))
                    return h(T, L, !0);
                if (T && "object" == typeof T)
                    return J = h(Object.entries(T).map((function (r) { return { key: r[0], value: r[1] }; })), L, !0), J && ((o = {})[J.key] = J.value, o);
                throw new Error("Cannot run selection expression on non-array " + JSON.stringify(T));
            case "Ternary":
                L = e.expression;
                var R = e.ifTrue, C = e.ifFalse, I = g(L);
                if (!0 === I)
                    return g(R);
                if (!1 === I || null === I)
                    return g(C);
                throw new Error("Unexpected non boolean/null in Ternary conditional expression: " + JSON.stringify(I));
            case "VariableReference":
                var z = s(e.variableName);
                if (u(z))
                    throw new Error("Null Pointer Exception: variable " + JSON.stringify(e.variableName) + " not found");
                return z.value;
        } }; return g; }; }, 304: function (r, e, n) { var t = this && this.__spreadArray || function (r, e, n) { if (n || 2 === arguments.length)
            for (var t, o = 0, i = e.length; o < i; o++)
                !t && o in e || (t || (t = Array.prototype.slice.call(e, 0, o)), t[o] = e[o]); return r.concat(t || Array.prototype.slice.call(e)); }, o = this && this.__importDefault || function (r) { return r && r.__esModule ? r : { default: r }; }; Object.defineProperty(e, "__esModule", { value: !0 }), e.parse = void 0; var i = n(543), a = o(n(320)); e.parse = function (r, e) { void 0 === e && (e = !1); var n = 0, o = function () { for (var r = [], e = 0; e < arguments.length; e++)
            r[e] = arguments[e]; }, u = { char: function (e) { var t; return n < r.length && (t = r.charAt(n++)) === e ? t : (t && t !== e && n--, null); }, chars: function (r) { for (var e = n, t = !0, o = 0; t && o < r.length; o++)
                t = Boolean(u.char(r[o])); return t ? r : (n = e, null); }, regExp: function (e) { var t; return n < r.length && (t = e.exec(r.substr(n))) && 0 === t.index ? (n += t[0].length, t[0]) : null; }, firstOf: function () { for (var r = [], e = 0; e < arguments.length; e++)
                r[e] = arguments[e]; for (var t = n, o = r.length, i = 0; i < o; i++) {
                var a = r[i]();
                if (null !== a)
                    return a;
                n = t;
            } return null; }, zeroOrMore: function (r) { for (;;) {
                var e = n;
                if (!r())
                    return n = e, !0;
            } }, whitSpc: function () { for (; n < r.length && "" === r.charAt(n).trim();)
                n += 1; return !0; }, identifier: function () { return u.regExp(/^([a-zA-Z_$][a-zA-Z0-9_$]*)/); }, stringLiteral: function () { var e = (0, a.default)(r.slice(n)); if (-1 === e)
                throw new i.ParsingError(r, n, "Non-terminating quoted string"); return e ? (n += e[1], e[0]) : null; } }, l = function () { o("expression"), u.whitSpc(); var t = f(); if (u.whitSpc(), u.char("?")) {
            if (u.char(":")) {
                o("after elvis operator");
                var a = l();
                if (o("after expression eaten post elvis"), !a && !e)
                    throw new i.ParsingError(r, n, "Expected expression after elvis (?:)");
                return { type: "Elvis", expression: t, ifFalse: a };
            }
            a = null;
            var s = null;
            if ((a = l()) && u.char(":") && (s = l()) || e)
                return { type: "Ternary", expression: t, ifTrue: a, ifFalse: s };
            throw new i.ParsingError(r, n, "Incomplete Ternary");
        } return t; }, f = function () { o("logicalOrExpression"), u.whitSpc(); var t = s(); return u.whitSpc(), u.zeroOrMore((function () { var o; if (u.whitSpc(), u.char("|")) {
            if (u.char("|")) {
                if ((o = s()) || e)
                    return t = { type: "OpOr", left: t, right: o };
                throw new i.ParsingError(r, n, "No right operand for ||");
            }
            throw new i.ParsingError(r, n, "Missing Character |");
        } return null; })), t; }, s = function () { o("logicalAndExpression"), u.whitSpc(); var t = c(); return u.whitSpc(), u.zeroOrMore((function () { var o; if (u.whitSpc(), u.char("&")) {
            if (u.char("&")) {
                if ((o = c()) || e)
                    return t = { type: "OpAnd", left: t, right: o };
                throw new i.ParsingError(r, n, "No right operand for &&");
            }
            throw new i.ParsingError(r, n, "Missing Character &");
        } return null; })), t; }, c = function () { o("relationalExpression"), u.whitSpc(); var t = p(), a = null, l = n; if (u.whitSpc(), u.char(">")) {
            if (u.char("=")) {
                if ((a = p()) || e)
                    return { type: "OpGE", left: t, right: a };
                throw new i.ParsingError(r, n, "No right operand for >=");
            }
            if ((a = p()) || e)
                return { type: "OpGT", left: t, right: a };
            throw new i.ParsingError(r, n, "No right operand for >");
        } if (u.char("<")) {
            if (u.char("=")) {
                if ((a = p()) || e)
                    return { type: "OpLE", left: t, right: a };
                throw new i.ParsingError(r, n, "No right operand for <=");
            }
            if ((a = p()) || e)
                return { type: "OpLT", left: t, right: a };
            throw new i.ParsingError(r, n, "No right operand for <");
        } if (u.char("!")) {
            if (u.char("=")) {
                if ((a = p()) || e)
                    return { type: "OpNE", left: t, right: a };
                throw new i.ParsingError(r, n, "No right operand for !=");
            }
            n = l;
        }
        else {
            if (u.char("=")) {
                if (o("got ="), u.char("=")) {
                    if ((a = p()) || e)
                        return { type: "OpEQ", left: t, right: a };
                    throw new i.ParsingError(r, n, "No right operand for ==");
                }
                throw new i.ParsingError(r, n, "Assignment not allowed");
            }
            var f = u.identifier();
            if ("matches" === f) {
                if ((a = p()) || e)
                    return { type: "OpMatches", left: t, right: a };
                throw new i.ParsingError(r, n, "No right operand for 'matches'");
            }
            if ("between" === f) {
                if ((a = p()) || e)
                    return { type: "OpBetween", left: t, right: a };
                throw new i.ParsingError(r, n, "No right operand for 'between'");
            }
            if (f)
                throw new i.ParsingError(r, n, "Not an Operator", '"'.concat(f, '" is not an operator'));
        } return o("fell through"), t; }, p = function () { o("sumExpression"), u.whitSpc(); var t = h(); return u.whitSpc(), o("sumExpression left", t), u.zeroOrMore((function () { u.whitSpc(), o("in zeroOrMore"); var a = null; if (u.char("+")) {
            if (o("pluscase"), !(a = h()) && !e)
                throw new i.ParsingError(r, n, "No right operand for +");
            return t = { type: "OpPlus", left: t, right: a };
        } if (u.char("-")) {
            if (o("minuscase"), !(a = h()) && !e)
                throw new i.ParsingError(r, n, "No right operand for -");
            return t = { type: "OpMinus", left: t, right: a };
        } return o("missed all"), null; })), t; }, h = function () { o("productExpression"), u.whitSpc(); var t = g(); return u.whitSpc(), u.zeroOrMore((function () { var o = null; if (u.char("*")) {
            if (!t)
                throw new i.ParsingError(r, n - 1, "No left operand for *");
            if ((o = g()) || e)
                return t = { type: "OpMultiply", left: t, right: o };
            throw new i.ParsingError(r, n, "No right operand for *");
        } if (u.char("/")) {
            if (!t)
                throw new i.ParsingError(r, n - 1, "No left operand for /");
            if ((o = g()) || e)
                return t = { type: "OpDivide", left: t, right: o };
            throw new i.ParsingError(r, n, "No right operand for /");
        } if (u.char("%")) {
            if (!t)
                throw new i.ParsingError(r, n - 1, "No left operand for %");
            if ((o = g()) || e)
                return t = { type: "OpModulus", left: t, right: o };
            throw new i.ParsingError(r, n, "No right operand for %");
        } return null; })), t; }, g = function () { o("powerExpression"), u.whitSpc(); var r = v(); u.whitSpc(); var e = n; return u.char("^") ? { type: "OpPower", base: r, expression: v() } : (n = e, r); }, v = function () { return o("unaryExpression"), u.firstOf(y, w, d); }, y = function () { o("negative"); var r = null; return u.char("-") && (r = v()) ? { type: "Negative", value: r } : (o("negative (null)"), null); }, w = function () { o("not"); var r = null; return u.char("!") && ((r = v()) || e) ? { type: "OpNot", expression: r } : null; }, d = function () { o("primaryExpression"), u.whitSpc(); var r = E(); o("after startNode got"); var e = []; return u.zeroOrMore((function () { var r; return (r = O()) ? (e.push(r), r) : null; })), e.length > 0 ? { type: "CompoundExpression", expressionComponents: t([r], e, !0) } : r; }, E = function () { return o("startNode"), u.firstOf(A, M, b, (function () { return P(!1); }), L); }, O = function () { return o("node"), u.firstOf(j, _, x, S, b); }, x = function () { if (o("navProperty"), u.char("."))
            return P(!1) || function () { if (e)
                return { type: "PropertyReference", propertyName: "", nullSafeNavigation: !1 }; throw new i.ParsingError(r, n, "Expected property after ."); }(); var t = n; return u.char("?") && u.char(".") ? P(!0) || function () { if (e)
            return { type: "PropertyReference", propertyName: "", nullSafeNavigation: !0 }; throw new i.ParsingError(r, n, "Expected property after ?."); }() : (n = t, null); }, S = function () { return o("indexExp"), u.firstOf(N, m); }, N = function () { o("nullSafeIndex"); var t = n, a = null; if (u.char("?") && u.char("[")) {
            if ((a = l()) || e) {
                if (u.char("]"))
                    return { type: "Indexer", nullSafeNavigation: !0, index: a };
                if (e)
                    return { type: "Indexer", nullSafeNavigation: !0, index: a, __unclosed: !0 };
                throw new i.ParsingError(r, n, "Expected ]");
            }
            if (u.char("]"))
                throw n -= 1, new i.ParsingError(r, n, "Expression expected in []");
            throw new i.ParsingError(r, n, "Expected ]");
        } return n = t, null; }, m = function () { o("notNullSafeIndex"); var t = n, a = null; if (u.char("[")) {
            if ((a = l()) || e) {
                if (u.char("]"))
                    return { type: "Indexer", nullSafeNavigation: !1, index: a };
                if (e)
                    return { type: "Indexer", nullSafeNavigation: !1, index: a, __unclosed: !0 };
                throw new i.ParsingError(r, n, "Expected ]");
            }
            if (u.char("]"))
                throw n -= 1, new i.ParsingError(r, n, "Expression expected in []");
            throw new i.ParsingError(r, n, "Expected ]");
        } return n = t, null; }, P = function (t) { o("methodOrProperty"), u.whitSpc(); var a, f = []; if (a = u.identifier()) {
            var s = n;
            if (u.char("(")) {
                if (u.zeroOrMore((function () { var r = l(); return r ? (f.push(r), u.char(","), r) : null; }))) {
                    if (u.char(")"))
                        return { type: "MethodReference", nullSafeNavigation: t, methodName: a, args: f };
                    if (e)
                        return { type: "MethodReference", nullSafeNavigation: t, methodName: a, args: f, __unclosed: !0 };
                }
                throw new i.ParsingError(r, n, "Expected ) for method call");
            }
            return n = s, { type: "PropertyReference", propertyName: a, nullSafeNavigation: t };
        } return null; }, b = function () { o("functionOrVar"), u.whitSpc(); var t = [], a = null; if (u.char("#") && (a = u.identifier())) {
            var f = n;
            if (u.char("(")) {
                if (u.zeroOrMore((function () { var r = l(); return r ? (t.push(r), u.char(","), r) : null; }))) {
                    if (u.char(")"))
                        return { type: "FunctionReference", nullSafeNavigation: !1, functionName: a, args: t };
                    if (e)
                        return { type: "FunctionReference", nullSafeNavigation: !1, functionName: a, args: t, __unclosed: !0 };
                }
                throw new i.ParsingError(r, n, "Expected ) for function call");
            }
            return n = f, { type: "VariableReference", variableName: a };
        } return null; }, _ = function () { o("selection"), u.whitSpc(); var t = n, a = u.char("?") ? !!u.char(".") || (n = t, null) : !u.char(".") && null; if (o("nullSafeNavigation " + a), null === a)
            return null; var f = u.firstOf((function () { var t; if (u.char("?") && u.char("[")) {
            if (u.whitSpc() && (t = l()) && u.whitSpc() && u.char("]"))
                return { type: "SelectionAll", nullSafeNavigation: a, expression: t };
            if (e)
                return { type: "SelectionAll", nullSafeNavigation: a, expression: t, __unclosed: !0 };
            throw new i.ParsingError(r, n, "Expected ] for selection expression ?[");
        } return null; }), (function () { var t; if (u.char("^") && u.char("[")) {
            if ((t = l()) && u.char("]"))
                return { type: "SelectionFirst", nullSafeNavigation: a, expression: t };
            if (e)
                return { type: "SelectionFirst", nullSafeNavigation: a, expression: t, __unclosed: !0 };
            throw new i.ParsingError(r, n, "Expected ] for selection expression ^[");
        } return null; }), (function () { var t; if (u.char("$") && u.char("[")) {
            if ((t = l()) && u.char("]"))
                return { type: "SelectionLast", nullSafeNavigation: a, expression: t };
            if (e)
                return { type: "SelectionLast", nullSafeNavigation: a, expression: t, __unclosed: !0 };
            throw new i.ParsingError(r, n, "Expected ] for selection expression $[");
        } return null; })); return null === f ? (n = t, null) : f; }, j = function () { o("projection"), u.whitSpc(); var t, a = n, f = u.char("?") ? !!u.char(".") || (n = a, null) : !u.char(".") && null; if (null === f)
            return null; if (u.char("!") && u.char("[")) {
            if ((t = l()) && u.char("]"))
                return { type: "Projection", nullSafeNavigation: f, expression: t };
            if (e)
                return { type: "Projection", nullSafeNavigation: f, expression: t, __unclosed: !0 };
            throw new i.ParsingError(r, n, "Expected ] for Projection expression ![");
        } return n = a, null; }, M = function () { return o("literal"), u.firstOf((function () { var r = u.stringLiteral(); return "string" == typeof r ? (o("returning stringLiteral", r), { type: "StringLiteral", value: r }) : null; }), J, (function () { return u.chars("true") && { type: "BooleanLiteral", value: !0 }; }), (function () { return u.chars("false") && { type: "BooleanLiteral", value: !1 }; }), (function () { return u.chars("null") && { type: "NullLiteral" }; })); }, A = function () { var t; if (o("parenExpression"), u.char("(")) {
            if ((t = l()) || e) {
                if (u.char(")") || e)
                    return t;
                throw new i.ParsingError(r, n, "Expected )");
            }
            if (u.char(")"))
                throw n -= 1, new i.ParsingError(r, n, "Expected expression in ()");
            throw new i.ParsingError(r, n, "Expected )");
        } return null; }, L = function () { o("inlineListOrMap"); var t = [], a = {}; if (u.whitSpc(), u.char("{")) {
            var f = n;
            if (u.zeroOrMore((function () { var r = l(); return r ? (t.push(r), u.char(","), u.whitSpc(), r) : null; }))) {
                if (u.char("}"))
                    return { type: "InlineList", elements: t };
                if (e)
                    return { type: "InlineList", elements: t, __unclosed: !0 };
            }
            if (n = f, u.zeroOrMore((function () { var r, e; return u.whitSpc(), (r = u.identifier()) && u.char(":") && (e = l()) ? (a[r] = e, u.char(","), e) : null; })) && u.whitSpc()) {
                if (u.char("}"))
                    return { type: "InlineMap", elements: a };
                if (e)
                    return { type: "InlineMap", elements: a, __unclosed: !0 };
            }
            else
                n = f;
            throw new i.ParsingError(r, n, "Expected }");
        } return null; }, J = function () { u.whitSpc(); var r = u.regExp(/\d+(?:\.\d+)?/); return r ? { type: "NumberLiteral", value: parseFloat(r) } : null; }, T = l(); if (n !== r.length && !e)
            throw new i.ParsingError(r, n, "Expression Remaining"); if (null === T && !e)
            throw new i.ParsingError(r, n, "Generic"); return T; }; }, 320: function (r, e) { Object.defineProperty(e, "__esModule", { value: !0 }); var n = { SINGLE_QUOTE: "'", DOUBLE_QUOTE: '"', TICK_QUOTE: "`" }, t = function (r) { return Object.values(n).includes(r); }; e.default = function (r) { var e = function (e, n) { var o = e, i = r[o]; if (n ? n === i : t(i)) {
            for (; r[++o] === i;)
                ;
            return { char: i, length: o - e, continueIx: o };
        } return null; }, n = function () { for (var e, n = 0; "" === (null === (e = r[n]) || void 0 === e ? void 0 : e.trim());)
            n += 1; return n; }(), o = r[n], i = t(o) ? o : null; if (i) {
            for (var a = n + 1; a < r.length;) {
                var u = e(a, i);
                if (u) {
                    if (u.length % 2 != 0) {
                        var l = a + u.length;
                        return [r.slice(n + 1, l - 1).split(i.repeat(2)).join(i), l];
                    }
                    a = u.continueIx + 1;
                }
                else
                    a += 1;
            }
            return -1;
        } return null; }; }, 631: function (r, e, n) { function t(r, e) { void 0 === e && (e = r.constructor); var n = Error.captureStackTrace; n && n(r, e); } n.r(e), n.d(e, { CustomError: function () { return a; }, customErrorFactory: function () { return l; } }); var o, i = (o = function (r, e) { return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (r, e) { r.__proto__ = e; } || function (r, e) { for (var n in e)
            Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]); }, o(r, e); }, function (r, e) { if ("function" != typeof e && null !== e)
            throw new TypeError("Class extends value " + String(e) + " is not a constructor or null"); function n() { this.constructor = r; } o(r, e), r.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n); }), a = function (r) { function e(e, n) { var o, i, a, u = this.constructor, l = r.call(this, e, n) || this; return Object.defineProperty(l, "name", { value: u.name, enumerable: !1, configurable: !0 }), o = l, i = u.prototype, (a = Object.setPrototypeOf) ? a(o, i) : o.__proto__ = i, t(l), l; } return i(e, r), e; }(Error), u = function (r, e, n) { if (n || 2 === arguments.length)
            for (var t, o = 0, i = e.length; o < i; o++)
                !t && o in e || (t || (t = Array.prototype.slice.call(e, 0, o)), t[o] = e[o]); return r.concat(t || Array.prototype.slice.call(e)); }; function l(r, e) { function n() { for (var o = [], i = 0; i < arguments.length; i++)
            o[i] = arguments[i]; if (!(this instanceof n))
            return new (n.bind.apply(n, u([void 0], o, !1))); e.apply(this, o), Object.defineProperty(this, "name", { value: r.name || e.name, enumerable: !1, configurable: !0 }), r.apply(this, o), t(this, n); } return void 0 === e && (e = Error), Object.defineProperties(n, { prototype: { value: Object.create(e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }) } }); } } }, e = {};
    function n(t) { var o = e[t]; if (void 0 !== o)
        return o.exports; var i = e[t] = { exports: {} }; return r[t].call(i.exports, i, i.exports, n), i.exports; }
    n.d = function (r, e) { for (var t in e)
        n.o(e, t) && !n.o(r, t) && Object.defineProperty(r, t, { enumerable: !0, get: e[t] }); }, n.o = function (r, e) { return Object.prototype.hasOwnProperty.call(r, e); }, n.r = function (r) { "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(r, "__esModule", { value: !0 }); };
    var t = {};
    return (function () { var r = t; Object.defineProperty(r, "__esModule", { value: !0 }), r.getEvaluator = r.parse = void 0; var e = n(750); Object.defineProperty(r, "getEvaluator", { enumerable: !0, get: function () { return e.getEvaluator; } }); var o = n(304); Object.defineProperty(r, "parse", { enumerable: !0, get: function () { return o.parse; } }); })(), t;
})(); }));

});

ace.define("ace/mode/spel_highlight_rules",[], function(require, exports, module){"use strict";
var oop = require("../lib/oop");
var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
var identifierRe = "#?[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*";
var JavaScriptHighlightRules = function (options) {
    var keywordMapper = this.createKeywordMapper({
        "variable.language": "#this|#root",
        "keyword": "matches|between",
        "constant.language": "null",
        "constant.language.boolean": "true|false"
    }, "identifier");
    var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|" + // hex
        "u[0-9a-fA-F]{4}|" + // unicode
        "u{[0-9a-fA-F]{1,6}}|" + // es6 unicode
        "[0-2][0-7]{0,2}|" + // oct
        "3[0-7][0-7]?|" + // oct
        "[4-7][0-7]?|" + //oct
        ".)";
    this.$rules = {
        "no_regex": [
            {
                token: "string",
                regex: "'(?=.)",
                next: "qstring"
            }, {
                token: "string",
                regex: '"(?=.)',
                next: "qqstring"
            }, {
                token: "constant.numeric",
                regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
            }, {
                token: "constant.numeric",
                regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
            }, {
                token: [
                    "storage.type", "punctuation.operator", "support.function",
                    "punctuation.operator", "entity.name.function", "text", "keyword.operator"
                ],
                regex: "(" + identifierRe + ")(\\.)(prototype)(\\.)(" + identifierRe + ")(\\s*)(=)",
                next: "function_arguments"
            }, {
                token: [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text", "storage.type", "text", "paren.lparen"
                ],
                regex: "(" + identifierRe + ")(\\.)(" + identifierRe + ")(\\s*)(=)(\\s*)(function\\*?)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token: [
                    "entity.name.function", "text", "keyword.operator", "text", "storage.type",
                    "text", "paren.lparen"
                ],
                regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)(function\\*?)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token: [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text",
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex: "(" + identifierRe + ")(\\.)(" + identifierRe + ")(\\s*)(=)(\\s*)(function\\*?)(\\s+)(\\w+)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token: [
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex: "(function\\*?)(\\s+)(" + identifierRe + ")(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token: [
                    "entity.name.function", "text", "punctuation.operator",
                    "text", "storage.type", "text", "paren.lparen"
                ],
                regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)(function\\*?)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token: [
                    "text", "text", "storage.type", "text", "paren.lparen"
                ],
                regex: "(:)(\\s*)(function\\*?)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token: "keyword",
                regex: "from(?=\\s*('|\"))"
            }, {
                token: "support.constant",
                regex: /that\b/
            }, {
                token: ["storage.type", "punctuation.operator", "support.function.firebug"],
                regex: /(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/
            }, {
                token: keywordMapper,
                regex: identifierRe
            }, {
                token: "punctuation.operator",
                regex: /[.](?![.])/,
                next: "property"
            }, {
                token: "storage.type",
                regex: /=>/,
                next: "start"
            }, {
                token: "keyword.operator",
                regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                next: "start"
            }, {
                token: "punctuation.operator",
                regex: /[?:,;.]/,
                next: "start"
            }, {
                token: "paren.lparen",
                regex: /[\[({]/,
                next: "start"
            }, {
                token: "paren.rparen",
                regex: /[\])}]/
            }, {
                token: "comment",
                regex: /^#!.*$/
            }
        ],
        property: [{
                token: "text",
                regex: "\\s+"
            }, {
                token: [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text",
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex: "(" + identifierRe + ")(\\.)(" + identifierRe + ")(\\s*)(=)(\\s*)(function\\*?)(?:(\\s+)(\\w+))?(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token: "punctuation.operator",
                regex: /[.](?![.])/
            }, {
                token: "identifier",
                regex: identifierRe
            }, {
                regex: "",
                token: "empty",
                next: "no_regex"
            }
        ],
        "start": [
            {
                token: "string.regexp",
                regex: "\\/",
                next: "regex"
            }, {
                token: "text",
                regex: "\\s+|^$",
                next: "start"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "regex": [
            {
                token: "regexp.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                token: "string.regexp",
                regex: "/[sxngimy]*",
                next: "no_regex"
            }, {
                token: "invalid",
                regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
            }, {
                token: "constant.language.escape",
                regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
            }, {
                token: "constant.language.delimiter",
                regex: /\|/
            }, {
                token: "constant.language.escape",
                regex: /\[\^?/,
                next: "regex_character_class"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp"
            }
        ],
        "regex_character_class": [
            {
                token: "regexp.charclass.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                token: "constant.language.escape",
                regex: "]",
                next: "regex"
            }, {
                token: "constant.language.escape",
                regex: "-"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp.charachterclass"
            }
        ],
        "default_parameter": [
            {
                token: "string",
                regex: "'(?=.)",
                push: [
                    {
                        token: "string",
                        regex: "'|$",
                        next: "pop"
                    }, {
                        include: "qstring"
                    }
                ]
            }, {
                token: "string",
                regex: '"(?=.)',
                push: [
                    {
                        token: "string",
                        regex: '"|$',
                        next: "pop"
                    }, {
                        include: "qqstring"
                    }
                ]
            }, {
                token: "constant.language",
                regex: "null"
            }, {
                token: "constant.numeric",
                regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
            }, {
                token: "constant.numeric",
                regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
            }, {
                token: "punctuation.operator",
                regex: ",",
                next: "function_arguments"
            }, {
                token: "text",
                regex: "\\s+"
            }, {
                token: "punctuation.operator",
                regex: "$"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "function_arguments": [
            {
                token: "variable.parameter",
                regex: identifierRe
            }, {
                token: "punctuation.operator",
                regex: ","
            }, {
                token: "text",
                regex: "\\s+"
            }, {
                token: "punctuation.operator",
                regex: "$"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "qqstring": [
            {
                token: "constant.language.escape",
                regex: escapedRe
            }, {
                token: "string",
                regex: "\\\\$",
                consumeLineEnd: true
            }, {
                token: "string",
                regex: '"|$',
                next: "no_regex"
            }, {
                defaultToken: "string"
            }
        ],
        "qstring": [
            {
                token: "constant.language.escape",
                regex: escapedRe
            }, {
                token: "string",
                regex: "\\\\$",
                consumeLineEnd: true
            }, {
                token: "string",
                regex: "'|$",
                next: "no_regex"
            }, {
                defaultToken: "string"
            }
        ]
    };
    this.normalizeRules();
};
oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
exports.SpelHighlightRules = JavaScriptHighlightRules;

});

ace.define("ace/mode/matching_brace_outdent",[], function(require, exports, module){"use strict";
var Range = require("../range").Range;
var MatchingBraceOutdent = function () { };
(function () {
    this.checkOutdent = function (line, input) {
        if (!/^\s+$/.test(line))
            return false;
        return /^\s*\}/.test(input);
    };
    this.autoOutdent = function (doc, row) {
        var line = doc.getLine(row);
        var match = line.match(/^(\s*\})/);
        if (!match)
            return 0;
        var column = match[1].length;
        var openBracePos = doc.findMatchingBracket({ row: row, column: column });
        if (!openBracePos || openBracePos.row == row)
            return 0;
        var indent = this.$getIndent(doc.getLine(openBracePos.row));
        doc.replace(new Range(row, 0, row, column - 1), indent);
    };
    this.$getIndent = function (line) {
        return line.match(/^\s*/)[0];
    };
}).call(MatchingBraceOutdent.prototype);
exports.MatchingBraceOutdent = MatchingBraceOutdent;

});

ace.define("ace/mode/folding/cstyle",[], function(require, exports, module){"use strict";
var oop = require("../../lib/oop");
var Range = require("../../range").Range;
var BaseFoldMode = require("./fold_mode").FoldMode;
var FoldMode = exports.FoldMode = function (commentRegex) {
    if (commentRegex) {
        this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
        this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
    }
};
oop.inherits(FoldMode, BaseFoldMode);
(function () {
    this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
    this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
    this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
    this._getFoldWidgetBase = this.getFoldWidget;
    this.getFoldWidget = function (session, foldStyle, row) {
        var line = session.getLine(row);
        if (this.singleLineBlockCommentRe.test(line)) {
            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
                return "";
        }
        var fw = this._getFoldWidgetBase(session, foldStyle, row);
        if (!fw && this.startRegionRe.test(line))
            return "start"; // lineCommentRegionStart
        return fw;
    };
    this.getFoldWidgetRange = function (session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
        if (this.startRegionRe.test(line))
            return this.getCommentRegionBlock(session, line, row);
        var match = line.match(this.foldingStartMarker);
        if (match) {
            var i = match.index;
            if (match[1])
                return this.openingBracketBlock(session, match[1], row, i);
            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
            if (range && !range.isMultiLine()) {
                if (forceMultiline) {
                    range = this.getSectionRange(session, row);
                }
                else if (foldStyle != "all")
                    range = null;
            }
            return range;
        }
        if (foldStyle === "markbegin")
            return;
        var match = line.match(this.foldingStopMarker);
        if (match) {
            var i = match.index + match[0].length;
            if (match[1])
                return this.closingBracketBlock(session, match[1], row, i);
            return session.getCommentFoldRange(row, i, -1);
        }
    };
    this.getSectionRange = function (session, row) {
        var line = session.getLine(row);
        var startIndent = line.search(/\S/);
        var startRow = row;
        var startColumn = line.length;
        row = row + 1;
        var endRow = row;
        var maxRow = session.getLength();
        while (++row < maxRow) {
            line = session.getLine(row);
            var indent = line.search(/\S/);
            if (indent === -1)
                continue;
            if (startIndent > indent)
                break;
            var subRange = this.getFoldWidgetRange(session, "all", row);
            if (subRange) {
                if (subRange.start.row <= startRow) {
                    break;
                }
                else if (subRange.isMultiLine()) {
                    row = subRange.end.row;
                }
                else if (startIndent == indent) {
                    break;
                }
            }
            endRow = row;
        }
        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
    };
    this.getCommentRegionBlock = function (session, line, row) {
        var startColumn = line.search(/\s*$/);
        var maxRow = session.getLength();
        var startRow = row;
        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
        var depth = 1;
        while (++row < maxRow) {
            line = session.getLine(row);
            var m = re.exec(line);
            if (!m)
                continue;
            if (m[1])
                depth--;
            else
                depth++;
            if (!depth)
                break;
        }
        var endRow = row;
        if (endRow > startRow) {
            return new Range(startRow, startColumn, endRow, line.length);
        }
    };
}).call(FoldMode.prototype);

});

ace.define("ace/mode/spel",[], function(require, exports, module){"use strict";
require('./spel_umd');
var oop = require("../lib/oop");
var TextMode = require("./text").Mode;
var HighlightRules = require("./spel_highlight_rules").SpelHighlightRules;
var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
var CstyleBehaviour = require("./behaviour/cstyle").CstyleBehaviour;
var CStyleFoldMode = require("./folding/cstyle").FoldMode;
var WorkerClient = require("../worker/worker_client").WorkerClient;
var Mode = function () {
    this.HighlightRules = HighlightRules;
    this.$outdent = new MatchingBraceOutdent();
    this.$behaviour = new CstyleBehaviour();
    this.foldingRules = new CStyleFoldMode();
};
oop.inherits(Mode, TextMode);
(function () {
    this.lineCommentStart = "//";
    this.blockComment = { start: "/*", end: "*/" };
    this.getNextLineIndent = function (state, line, tab) {
        var indent = this.$getIndent(line);
        if (state == "start") {
            var match = line.match(/^.*[\{\(\[]\s*$/);
            if (match) {
                indent += tab;
            }
        }
        return indent;
    };
    this.checkOutdent = function (state, line, input) {
        return this.$outdent.checkOutdent(line, input);
    };
    this.autoOutdent = function (state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
    };
    this.createWorker = function (session) {
        var worker = new WorkerClient(["ace"], "ace/mode/spel_worker", "SpelWorker");
        worker.attachToDocument(session.getDocument());
        worker.on("annotate", function (e) {
            session.setAnnotations(e.data);
        });
        worker.on("terminate", function () {
            session.clearAnnotations();
        });
        return worker;
    };
    this.$id = "ace/mode/spel";
}).call(Mode.prototype);
exports.Mode = Mode;

});                (function() {
                    ace.require(["ace/mode/spel"], function(m) {
                        if (typeof module == "object" && typeof exports == "object" && module) {
                            module.exports = m;
                        }
                    });
                })();
            